"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRoleTypeToJSON = exports.UserRoleTypeFromJSONTyped = exports.UserRoleTypeFromJSON = exports.UserRoleType = void 0;
/**
 *
 *
 * 0 = Admin
 *
 * 1 = User
 * @export
 * @enum {string}
 */
var UserRoleType;
(function (UserRoleType) {
    UserRoleType[UserRoleType["NUMBER_0"] = 0] = "NUMBER_0";
    UserRoleType[UserRoleType["NUMBER_1"] = 1] = "NUMBER_1";
})(UserRoleType = exports.UserRoleType || (exports.UserRoleType = {}));
function UserRoleTypeFromJSON(json) {
    return UserRoleTypeFromJSONTyped(json, false);
}
exports.UserRoleTypeFromJSON = UserRoleTypeFromJSON;
function UserRoleTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.UserRoleTypeFromJSONTyped = UserRoleTypeFromJSONTyped;
function UserRoleTypeToJSON(value) {
    return value;
}
exports.UserRoleTypeToJSON = UserRoleTypeToJSON;
